import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Mặt hàng sản xuất, dịch vụ chính", -1)
const _hoisted_5 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian báo cáo: ", -1)
const _hoisted_7 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Lập hồ sơ vệ sinh lao động theo Nghị định 39/2016/NĐ-CP: ", -1)
const _hoisted_10 = { class: "p-field-radiobutton" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "yes" }, " Có", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "no" }, " Không", -1)
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Người làm công tác y tế: ", -1)
const _hoisted_15 = { class: "p-field-radiobutton" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "yes1" }, " Có", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "no1" }, " Không", -1)
const _hoisted_18 = {
  key: 0,
  class: "p-field p-col-12 p-md-12"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Nếu có, ghi rõ thông tin về người làm công tác y tế tại cơ sở lao động:", -1)
const _hoisted_20 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Trạm/phòng y tế/phòng khám /bệnh viện: ", -1)
const _hoisted_22 = { class: "p-field-radiobutton" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "yes2" }, " Có", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "no2" }, " Không", -1)
const _hoisted_25 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-8 p-lg-8"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Nếu có, ghi cụ thể hình thức tổ chức:", -1)
const _hoisted_27 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Thuê, hợp đồng với đơn vị y tế: ", -1)
const _hoisted_29 = { class: "p-field-radiobutton" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "yes3" }, " Có", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "no3" }, " Không", -1)
const _hoisted_32 = {
  key: 2,
  class: "p-field p-col-12 p-md-12"
}
const _hoisted_33 = { class: "p-fluid" }
const _hoisted_34 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_35 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Tên cơ sở cung cấp dịch vụ:", -1)
const _hoisted_37 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", null, "Địa chỉ:", -1)
const _hoisted_39 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại liên hệ: ", -1)
const _hoisted_41 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung cung cấp dịch vụ:", -1)
const _hoisted_43 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", null, "Thời gian cung cấp dịch vụ:", -1)
const _hoisted_45 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", null, "Lực lượng sơ cứu, cấp cứu (SCCC) tại nơi làm việc (đối với cơ sở sản xuất kinh doanh): ", -1)
const _hoisted_47 = { class: "p-field-radiobutton" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "yes4" }, " Có", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { for: "no4" }, " Không", -1)
const _hoisted_50 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_51 = { class: "p-fluid" }
const _hoisted_52 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_53 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", null, "Số lượng lực lượng SCCC được huấn luyện SCCC:", -1)
const _hoisted_55 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", null, "Trong đó số nữ:", -1)
const _hoisted_57 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", null, "Số lượng người lao động được huấn luyện SCCC:", -1)
const _hoisted_59 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", null, "Trong đó số nữ:", -1)
const _hoisted_61 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", null, "Công tác thanh tra, kiểm tra việc thực hiện công tác vệ sinh lao động, chăm sóc sức khỏe người lao động, phòng chống bệnh nghề nghiệp trong kỳ báo cáo (của các cơ quan chức năng đối với cơ sở lao động)", -1)
const _hoisted_63 = { class: "p-fluid" }
const _hoisted_64 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_65 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", null, "Quan trắc môi trường lao động hàng năm: ", -1)
const _hoisted_67 = { class: "p-field-radiobutton" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { for: "yes11" }, " Có", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { for: "no11" }, " Không", -1)
const _hoisted_70 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", null, "Lần sau cùng ngày : ", -1)
const _hoisted_72 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", null, "Tổ chức thực hiện QTMTLĐ (ghi tên, địa chỉ, SĐT):", -1)
const _hoisted_74 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_75 = { class: "p-fluid" }
const _hoisted_76 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_77 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", null, "Silic", -1)
const _hoisted_79 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", null, "Khác", -1)
const _hoisted_81 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-12 p-lg-12"
}
const _hoisted_82 = { class: "p-fluid" }
const _hoisted_83 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_84 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", null, "Silic", -1)
const _hoisted_86 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", null, "Khác", -1)
const _hoisted_88 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-12 p-lg-12"
}
const _hoisted_89 = { class: "p-fluid" }
const _hoisted_90 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_91 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", null, "Số lượt người nghỉ ốm, tai nạn lao động và bệnh nghề nghiệp: ", -1)
const _hoisted_93 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số ngày nghỉ ốm, tai nạn lao động và bệnh nghề nghiệp: ", -1)
const _hoisted_95 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Ghi chú:"),
  /*#__PURE__*/_createElementVNode("label", null, "- Cột 2, 4: Tổng số người lao động nghỉ ốm, nghỉ do tai nạn lao động."),
  /*#__PURE__*/_createElementVNode("label", null, "- Cột 6: Tổng số người lao động tiếp xúc với yếu tố có hại gây bệnh nghề nghiệp."),
  /*#__PURE__*/_createElementVNode("label", null, "- Cột 3, 5, 7: Số ngày nghỉ do ốm, tai nạn lao động và bệnh nghề nghiệp.")
], -1)
const _hoisted_97 = { class: "p-fluid" }
const _hoisted_98 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_99 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", null, "Tổ chức khám bệnh nghề nghiệp: ", -1)
const _hoisted_101 = { class: "p-field-radiobutton" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { for: "yes21" }, " Có", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", { for: "no21" }, " Không", -1)
const _hoisted_104 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", null, "Năm khám BNN gần nhất:", -1)
const _hoisted_106 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", null, "Đơn vị thực hiện khám bệnh nghề nghiệp (ghi tên, địa chỉ, SĐT):", -1)
const _hoisted_108 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", null, "Số người được khám BNN/ Tổng số NLĐ tiếp xúc yếu tố có hại: ", -1)
const _hoisted_110 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", null, "Trong đó nữ: ", -1)
const _hoisted_112 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_113 = { class: "p-fluid" }
const _hoisted_114 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_115 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", null, "* Danh sách trường hợp bệnh nghề nghiệp theo năm báo cáo, không báo cáo lặp lại các năm.")
], -1)
const _hoisted_117 = { class: "p-fluid" }
const _hoisted_118 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_119 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_120 = { class: "p-fluid" }
const _hoisted_121 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_122 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_123 = { class: "p-fluid" }
const _hoisted_124 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_125 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "p-fluid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-fluid p-formgrid p-grid" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-md-12" }, [
      /*#__PURE__*/_createElementVNode("label", null, " Thống kê kết quả khám, chẩn đoán của người lao động tự đi khám hoặc phân loại bệnh thông qua khám sức khỏe định kỳ hoặc khám phát hiện sớm bệnh nghề nghiệp tại cơ sở lao động. ")
    ])
  ])
], -1)
const _hoisted_127 = { class: "p-fluid" }
const _hoisted_128 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_129 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_130 = { class: "p-fluid" }
const _hoisted_131 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_132 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_133 = { class: "p-fluid" }
const _hoisted_134 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_135 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_136 = { class: "p-fluid" }
const _hoisted_137 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_138 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_139 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_140 = { class: "p-fluid" }
const _hoisted_141 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_142 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_143 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "I. Thông tin chung" }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createVNode(_component_InputText, {
                        id: "matHangSanXuat",
                        type: "text",
                        modelValue: $setup.baoCaoCoSoLaoDong.matHangSanXuat,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.baoCaoCoSoLaoDong.matHangSanXuat) = $event)),
                        placeholder: "Mặt hàng sản xuất chính"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createVNode(_component_Calendar, {
                        modelValue: $setup.baoCaoCoSoLaoDong.thoiGianBC,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.baoCaoCoSoLaoDong.thoiGianBC) = $event)),
                        touchUI: "",
                        view: "month",
                        dateFormat: "mm/yy"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCaoCoSoLaoDong.nguoiLaoDongs,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            headerStyle: "width:3rem"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "noiDung",
                            header: "Nội dung"
                          }),
                          _createVNode(_component_Column, {
                            field: "soLuong",
                            header: "Số lượng"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "soLuong",
                                type: "text",
                                modelValue: slotProps.data.soLuong,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuong) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "nu",
                            header: "Số nữ"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "soNu",
                                type: "text",
                                modelValue: slotProps.data.nu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.nu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "ghiChu",
                            header: "Ghi chú"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "ghiChu",
                                type: "text",
                                modelValue: slotProps.data.ghiChu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "yes",
                          name: "act",
                          value: true,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.baoCaoCoSoLaoDong.lapHoSoLaoDong) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.lapHoSoLaoDong]
                        ]),
                        _hoisted_11,
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "no",
                          name: "act",
                          value: false,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.baoCaoCoSoLaoDong.lapHoSoLaoDong) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.lapHoSoLaoDong]
                        ]),
                        _hoisted_12
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "yes1",
                          name: "act2",
                          value: true,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.baoCaoCoSoLaoDong.lamCongTacYTe) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.lamCongTacYTe]
                        ]),
                        _hoisted_16,
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "no1",
                          name: "act2",
                          value: false,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.baoCaoCoSoLaoDong.lamCongTacYTe) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.lamCongTacYTe]
                        ]),
                        _hoisted_17
                      ])
                    ]),
                    ($setup.baoCaoCoSoLaoDong.lamCongTacYTe)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_Toolbar, { class: "mb-6" }, {
                            start: _withCtx(() => [
                              _createVNode(_component_Button, {
                                label: "Thêm",
                                severity: "secondary",
                                icon: "pi pi-plus",
                                class: "mr-2",
                                onClick: $setup.addThongTin
                              }, null, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_DataTable, {
                            value: $setup.baoCaoCoSoLaoDong.thongTinLaoDongs,
                            showGridlines: "",
                            rows: 40,
                            rowHover: true,
                            style: {"font-size":"14px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "Stt",
                                headerStyle: "width:3rem"
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "hoVaTen",
                                header: "Họ và tên",
                                sortable: ""
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode(_component_InputText, {
                                    id: "hoVaTen",
                                    type: "text",
                                    modelValue: slotProps.data.hoVaTen,
                                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.hoVaTen) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "trinhDoChuyenMon",
                                header: "Trình độ chuyên môn"
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode(_component_InputText, {
                                    id: "trinhDoChuyenMon",
                                    type: "text",
                                    modelValue: slotProps.data.trinhDoChuyenMon,
                                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.trinhDoChuyenMon) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "soDienThoai",
                                header: "Số điện thoại liên hệ"
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode(_component_InputText, {
                                    id: "soDienThoai",
                                    type: "text",
                                    modelValue: slotProps.data.soDienThoai,
                                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.soDienThoai) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "chungChi",
                                header: "Chứng chỉ chứng nhận chuyên môn về y tế lao động* "
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode(_component_InputText, {
                                    id: "chungChi",
                                    type: "text",
                                    modelValue: slotProps.data.chungChi,
                                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.chungChi) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "yes2",
                          name: "act3",
                          value: true,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.baoCaoCoSoLaoDong.tramYTe) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.tramYTe]
                        ]),
                        _hoisted_23,
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "no2",
                          name: "act3",
                          value: false,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.baoCaoCoSoLaoDong.tramYTe) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.tramYTe]
                        ]),
                        _hoisted_24
                      ])
                    ]),
                    ($setup.baoCaoCoSoLaoDong.tramYTe)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(_component_InputText, {
                            id: "cuTheHinhThuc",
                            type: "text",
                            modelValue: $setup.baoCaoCoSoLaoDong.cuTheHinhThuc,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.baoCaoCoSoLaoDong.cuTheHinhThuc) = $event)),
                            placeholder: ""
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "yes3",
                          name: "act4",
                          value: true,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.baoCaoCoSoLaoDong.thueDonVi) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.thueDonVi]
                        ]),
                        _hoisted_30,
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "no3",
                          name: "act4",
                          value: false,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.baoCaoCoSoLaoDong.thueDonVi) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.thueDonVi]
                        ]),
                        _hoisted_31
                      ])
                    ]),
                    ($setup.baoCaoCoSoLaoDong.thueDonVi)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createVNode(_component_Panel, { header: "Thông báo thông tin cơ sở khám bệnh, chữa bệnh trên theo mẫu tại Phụ lục XXII, Nghị định 39/2016/NĐ-CP ngày 15/5/2016" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, [
                                    _hoisted_36,
                                    _createVNode(_component_InputText, {
                                      id: "ten",
                                      type: "text",
                                      modelValue: $setup.baoCaoCoSoLaoDong.tenCoSoCungCapDichVu,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.baoCaoCoSoLaoDong.tenCoSoCungCapDichVu) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _hoisted_38,
                                    _createVNode(_component_InputText, {
                                      id: "dc",
                                      type: "text",
                                      modelValue: $setup.baoCaoCoSoLaoDong.diaChiDV,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.baoCaoCoSoLaoDong.diaChiDV) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _hoisted_40,
                                    _createVNode(_component_InputText, {
                                      id: "dt",
                                      type: "text",
                                      modelValue: $setup.baoCaoCoSoLaoDong.dienThoaiDV,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.baoCaoCoSoLaoDong.dienThoaiDV) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_41, [
                                    _hoisted_42,
                                    _createVNode(_component_InputText, {
                                      id: "nd",
                                      type: "text",
                                      modelValue: $setup.baoCaoCoSoLaoDong.noiDungDV,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.baoCaoCoSoLaoDong.noiDungDV) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_43, [
                                    _hoisted_44,
                                    _createVNode(_component_Calendar, {
                                      modelValue: $setup.baoCaoCoSoLaoDong.thoiGianBC,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.baoCaoCoSoLaoDong.thoiGianBC) = $event)),
                                      touchUI: "",
                                      dateFormat: "dd/mm/yy"
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("div", _hoisted_47, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "yes4",
                          name: "act5",
                          value: true,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.baoCaoCoSoLaoDong.lucLuongSoCuu) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.lucLuongSoCuu]
                        ]),
                        _hoisted_48,
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "no4",
                          name: "act5",
                          value: false,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.baoCaoCoSoLaoDong.lucLuongSoCuu) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.lucLuongSoCuu]
                        ]),
                        _hoisted_49
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_Panel, { header: "Lực lượng sơ cứu, cấp cứu" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _hoisted_54,
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: $setup.baoCaoCoSoLaoDong.soLucLuongSCCC,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.baoCaoCoSoLaoDong.soLucLuongSCCC) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_55, [
                                _hoisted_56,
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: $setup.baoCaoCoSoLaoDong.soLucLuongNuSCCC,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.baoCaoCoSoLaoDong.soLucLuongNuSCCC) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _hoisted_58,
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: $setup.baoCaoCoSoLaoDong.soLaoDongSCCC,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.baoCaoCoSoLaoDong.soLaoDongSCCC) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                _hoisted_60,
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: $setup.baoCaoCoSoLaoDong.soLaoDongNuSCCC,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.baoCaoCoSoLaoDong.soLaoDongNuSCCC) = $event))
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createVNode(_component_Toolbar, { class: "mb-6" }, {
                        start: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Thêm",
                            severity: "secondary",
                            icon: "pi pi-plus",
                            class: "mr-2",
                            onClick: $setup.addKiemTra
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCaoCoSoLaoDong.kiemTraVeSinhLaoDongs,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            headerStyle: "width:3rem"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "ngayKiemTra",
                            header: "Ngày kiểm tra"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_Calendar, {
                                modelValue: slotProps.data.ngayKiemTra,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ngayKiemTra) = $event),
                                touchUI: "",
                                dateFormat: "dd/mm/yy"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "donViKiemTra",
                            header: "Đơn vị kiểm tra"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "donViKiemTra",
                                type: "text",
                                modelValue: slotProps.data.donViKiemTra,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.donViKiemTra) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "noiDungKiemTra",
                            header: "Nội dung kiểm tra"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "noiDungKiemTra",
                                type: "text",
                                modelValue: slotProps.data.noiDungKiemTra,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.noiDungKiemTra) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "ghiChu",
                            header: "Ghi chú"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "ghiChu2",
                                type: "text",
                                modelValue: slotProps.data.ghiChu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "II. Điều kiện lao động và số lao động tiếp xúc với yếu tố có hại (Đính kèm)" }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("div", _hoisted_67, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "yes11",
                          name: "act6",
                          value: true,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.baoCaoCoSoLaoDong.quanTracMoiTruong) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.quanTracMoiTruong]
                        ]),
                        _hoisted_68,
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "no11",
                          name: "act6",
                          value: false,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.baoCaoCoSoLaoDong.quanTracMoiTruong) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.quanTracMoiTruong]
                        ]),
                        _hoisted_69
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createVNode(_component_Calendar, {
                        modelValue: $setup.baoCaoCoSoLaoDong.thoiGianQuanTracMoiTruong,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.baoCaoCoSoLaoDong.thoiGianQuanTracMoiTruong) = $event)),
                        touchUI: "",
                        dateFormat: "dd/mm/yy"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _createVNode(_component_InputText, {
                        id: "toChucThucHienQTMT",
                        type: "text",
                        modelValue: $setup.baoCaoCoSoLaoDong.toChucThucHienQTMT,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.baoCaoCoSoLaoDong.toChucThucHienQTMT) = $event)),
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_Toolbar, { class: "mb-6" }, {
                        start: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Thêm",
                            severity: "secondary",
                            icon: "pi pi-plus",
                            class: "mr-2",
                            onClick: $setup.addDieuKien
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCaoCoSoLaoDong.dieuKienLaoDongs,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TT",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Yếu tố quan trắc",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tổng số mẫu",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số mẫu không đạt",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số lao động tiếp xúc",
                                    colspan: 2
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Tổng số",
                                    rowspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Trong đó số nữ",
                                    rowspan: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "Stt",
                            headerStyle: "width:3rem"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "yeuToQuanTrac",
                            header: "Yếu tố quan trắc"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "yeuToQuanTrac",
                                type: "text",
                                modelValue: slotProps.data.yeuToQuanTrac,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.yeuToQuanTrac) = $event),
                                placeholder: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Tổng số mẫu"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("div", _hoisted_75, [
                                _createElementVNode("div", _hoisted_76, [
                                  (slotProps.data.tongSoMaus.bui)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                        _hoisted_78,
                                        _createVNode(_component_InputNumber, {
                                          inputId: "integeronly",
                                          modelValue: slotProps.data.tongSoMaus.silic,
                                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoMaus.silic) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (slotProps.data.tongSoMaus.bui)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                        _hoisted_80,
                                        _createVNode(_component_InputNumber, {
                                          inputId: "integeronly",
                                          modelValue: slotProps.data.tongSoMaus.khac,
                                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoMaus.khac) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!slotProps.data.tongSoMaus.bui)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                        _createVNode(_component_InputNumber, {
                                          inputId: "integeronly",
                                          modelValue: slotProps.data.tongSoMaus.tongSo,
                                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoMaus.tongSo) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Số mẫu không đạt"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("div", _hoisted_83, [
                                  (slotProps.data.soMauKhongDats.bui)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                        _hoisted_85,
                                        _createVNode(_component_InputNumber, {
                                          inputId: "integeronly",
                                          modelValue: slotProps.data.soMauKhongDats.silic,
                                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.soMauKhongDats.silic) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (slotProps.data.soMauKhongDats.bui)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                        _hoisted_87,
                                        _createVNode(_component_InputNumber, {
                                          inputId: "integeronly",
                                          modelValue: slotProps.data.soMauKhongDats.khac,
                                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.soMauKhongDats.khac) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!slotProps.data.soMauKhongDats.bui)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                        _createVNode(_component_InputNumber, {
                                          inputId: "integeronly",
                                          modelValue: slotProps.data.soMauKhongDats.tongSo,
                                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.soMauKhongDats.tongSo) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số (Số lao động tiếp xúc)"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "nu",
                            header: "Trong đó số nữ (Số lao động tiếp xúc)"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.nu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.nu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "III. Nghỉ việc do ốm đau, tai nạn lao động và bệnh nghề nghiệp" }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _hoisted_92,
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: $setup.baoCaoCoSoLaoDong.soLuotNghiOm,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.baoCaoCoSoLaoDong.soLuotNghiOm) = $event)),
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _hoisted_94,
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        type: "text",
                        modelValue: $setup.baoCaoCoSoLaoDong.soNgayNghiOm,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.baoCaoCoSoLaoDong.soNgayNghiOm) = $event)),
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCaoCoSoLaoDong.nghiViecDoOms,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Thời gian",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Ốm",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tai nạn lao động",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Bệnh nghề nghiệp",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tổng số",
                                    colspan: 2
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Quý",
                                    field: "quy"
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tháng (1)",
                                    field: "thisYearSale"
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số người (2)",
                                    field: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tổng số ngày (3)",
                                    field: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số người (4)",
                                    field: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tổng số ngày (5)",
                                    field: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số người (6)",
                                    field: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tổng số ngày (7)",
                                    field: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số người (8)",
                                    field: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tổng số ngày (9)",
                                    field: ""
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "quy",
                            header: "Quý"
                          }),
                          _createVNode(_component_Column, {
                            field: "thang",
                            header: "Tháng"
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Số người"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.oms.soNguoi,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.oms.soNguoi) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Tổng số ngày"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.oms.tongSoNgay,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.oms.tongSoNgay) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Số người"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.taiNanLaoDongs.soNguoi,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.taiNanLaoDongs.soNguoi) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Tổng số ngày"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.taiNanLaoDongs.tongSoNgay,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.taiNanLaoDongs.tongSoNgay) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Số người"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.benhNgheNghieps.soNguoi,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.benhNgheNghieps.soNguoi) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Tổng số ngày"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.benhNgheNghieps.tongSoNgay,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.benhNgheNghieps.tongSoNgay) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Số người"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSos.soNguoi,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSos.soNguoi) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Tổng số ngày"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSos.tongSoNgay,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSos.tongSoNgay) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _hoisted_96
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "IV. Bệnh nghề nghiệp được bảo hiểm" }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "Tổng hợp tình hình bệnh nghề nghiệp tại cơ sở lao động (Đính kèm báo cáo kết quả tổng hợp khám BNN)" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _hoisted_100,
                      _createElementVNode("div", _hoisted_101, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "yes21",
                          name: "act7",
                          value: true,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.baoCaoCoSoLaoDong.toChucKBNN) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.toChucKBNN]
                        ]),
                        _hoisted_102,
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "no21",
                          name: "act7",
                          value: false,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.baoCaoCoSoLaoDong.toChucKBNN) = $event))
                        }, null, 512), [
                          [_vModelRadio, $setup.baoCaoCoSoLaoDong.toChucKBNN]
                        ]),
                        _hoisted_103
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _hoisted_105,
                      _createVNode(_component_Calendar, {
                        modelValue: $setup.baoCaoCoSoLaoDong.namKBNN,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.baoCaoCoSoLaoDong.namKBNN) = $event)),
                        view: "year",
                        touchUI: "",
                        dateFormat: "yy"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _hoisted_107,
                      _createVNode(_component_InputText, {
                        id: "donViThucHienKBNN",
                        type: "text",
                        modelValue: $setup.baoCaoCoSoLaoDong.donViThucHienKBNN,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.baoCaoCoSoLaoDong.donViThucHienKBNN) = $event)),
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _hoisted_109,
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: $setup.baoCaoCoSoLaoDong.tongSoKBNN,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.baoCaoCoSoLaoDong.tongSoKBNN) = $event)),
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _hoisted_111,
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: $setup.baoCaoCoSoLaoDong.soNuKBNN,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.baoCaoCoSoLaoDong.soNuKBNN) = $event)),
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_112, [
                      _createVNode(_component_Toolbar, { class: "mb-6" }, {
                        start: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Thêm",
                            severity: "secondary",
                            icon: "pi pi-plus",
                            class: "mr-2",
                            onClick: $setup.addBenhBH
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCaoCoSoLaoDong.benhNgheNghiepDuocBhs,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TT",
                                    rowspan: 3
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tên bệnh nghề nghiệp",
                                    rowspan: 3,
                                    style: {"width":"300px"}
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "NLĐ được khám sức khỏe phát hiện BNN",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "NLĐ được chẩn đoán BNN",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "NLĐ được giám định BNN",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Kết quả giám định BNN",
                                    colspan: 6
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Tổng số",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số nữ",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tổng số",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số nữ",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tổng số",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số nữ",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "<5%",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "5 - 30%",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: ">=31%",
                                    colspan: 2
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TS",
                                    rowspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nữ",
                                    rowspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "TS",
                                    rowspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nữ",
                                    rowspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "TS",
                                    rowspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nữ",
                                    rowspan: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "Stt",
                            headerStyle: "width:3rem"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tenBenh",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "tenBenh",
                                type: "text",
                                modelValue: slotProps.data.tenBenh,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenBenh) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.phatBenhKhiKham.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.phatBenhKhiKham.tongSo) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.phatBenhKhiKham.nu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.phatBenhKhiKham.nu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.duocChanDoanBenh.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.duocChanDoanBenh.tongSo) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.duocChanDoanBenh.nu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.duocChanDoanBenh.nu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.duocGiamDinh.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.duocGiamDinh.tongSo) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.duocGiamDinh.nu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.duocGiamDinh.nu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.ketQuaDuoi5.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaDuoi5.tongSo) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.ketQuaDuoi5.nu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaDuoi5.nu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.ketQuaTu5Den30.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaTu5Den30.tongSo) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.ketQuaTu5Den30.nu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaTu5Den30.nu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.ketQuaTren31.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaTren31.tongSo) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.ketQuaTren31.nu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ketQuaTren31.nu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Panel, { header: "Danh sách trường hợp bệnh nghề nghiệp" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("div", _hoisted_115, [
                      _createVNode(_component_Toolbar, { class: "mb-6" }, {
                        start: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Thêm",
                            severity: "secondary",
                            icon: "pi pi-plus",
                            class: "mr-2",
                            onClick: $setup.addBenhNN
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCaoCoSoLaoDong.danhSachTruongHopBenhNgheNghieps,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TT",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Họ tên bệnh nhân",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tuổi",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nghề khi bị BNN",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tuổi nghề",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Ngày phát hiện bệnh",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tên BNN",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tỷ lệ suy giảm KNLĐ",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Công việc hiện nay",
                                    rowspan: 2
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Nam",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nữ",
                                    colspan: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "",
                            headerStyle: "width:3rem"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tenBenhNhan",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "tenBenhNhan",
                                type: "text",
                                modelValue: slotProps.data.tenBenhNhan,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenBenhNhan) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tuoiNam,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tuoiNam) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tuoiNu,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tuoiNu) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "ngheKhiBiBenh",
                                type: "text",
                                modelValue: slotProps.data.ngheKhiBiBenh,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ngheKhiBiBenh) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tuoiNghe,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tuoiNghe) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_Calendar, {
                                modelValue: slotProps.data.thoiGianPhatHien,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.thoiGianPhatHien) = $event),
                                touchUI: "",
                                dateFormat: "dd/mm/yy"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "tenBenh",
                                type: "text",
                                modelValue: slotProps.data.tenBenh,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenBenh) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tyLeSuyGiamKNLD,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tyLeSuyGiamKNLD) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "congViecHienNay",
                                type: "text",
                                modelValue: slotProps.data.congViecHienNay,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.congViecHienNay) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ]),
                  _hoisted_116
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "V. Tình hình bệnh tật và tai nạn lao động" }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "I. Số trường hợp mắc các loại bệnh thông thường:" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      _createVNode(_component_Toolbar, { class: "mb-6" }, {
                        start: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Thêm",
                            severity: "secondary",
                            icon: "pi pi-plus",
                            class: "mr-2",
                            onClick: $setup.addBenhTNLD
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCaoCoSoLaoDong.tinhHinhBenhTatVaTnlds,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            headerStyle: "width:3rem"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "nhomBenh",
                            header: "Nhóm bệnh"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "nhomBenh",
                                type: "text",
                                modelValue: slotProps.data.nhomBenh,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.nhomBenh) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "6 tháng đầu năm"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.sauThangDauNam.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangDauNam.tongSo) = $event),
                                placeholder: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "6 tháng cuối năm"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.sauThangCuoiNam.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangCuoiNam.tongSo) = $event),
                                placeholder: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Panel, { header: "II. Các trường hợp mắc bệnh nghề nghiệp" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCaoCoSoLaoDong.tinhHinhBenhTatMacBenhNN,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            headerStyle: "width:3rem"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "nhomBenh",
                            header: "Nhóm bệnh"
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "6 tháng đầu năm"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.sauThangDauNam.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangDauNam.tongSo) = $event),
                                placeholder: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "6 tháng cuối năm"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.sauThangCuoiNam.tongSo,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangCuoiNam.tongSo) = $event),
                                placeholder: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Panel, { header: "III. Các trường hợp tai nạn lao động (Z04.2)" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("div", _hoisted_125, [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCaoCoSoLaoDong.tinhHinhTnld,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TT",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nhóm bệnh",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "6 tháng đầu năm",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "6 tháng cuối năm",
                                    colspan: 2
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Mắc",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Chết",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Mắc",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Chết",
                                    colspan: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "Stt",
                            headerStyle: "width:3rem"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "nhomBenh",
                            header: "Nhóm bệnh"
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.sauThangDauNam.mac,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangDauNam.mac) = $event),
                                placeholder: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.sauThangDauNam.chet,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangDauNam.chet) = $event),
                                placeholder: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.sauThangCuoiNam.mac,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangCuoiNam.mac) = $event),
                                placeholder: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.sauThangCuoiNam.chet,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sauThangCuoiNam.chet) = $event),
                                placeholder: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _hoisted_126
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "VI. Phân loại sức khỏe" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("div", _hoisted_129, [
                  _createVNode(_component_DataTable, {
                    value: $setup.baoCaoCoSoLaoDong.phanLoaiSucKhoes,
                    showGridlines: "",
                    rows: 40,
                    rowHover: true,
                    style: {"font-size":"14px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "Stt",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soNguoiDuocKSK",
                        header: "Số người được KSK định kỳ"
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSo",
                        header: "Tổng số"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSo,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event),
                            placeholder: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "loaiI",
                        header: "Loại I"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.loaiI,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiI) = $event),
                            placeholder: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "loaiII",
                        header: "Loại II"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.loaiII,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiII) = $event),
                            placeholder: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "loaiIII",
                        header: "Loại III"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.loaiIII,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiIII) = $event),
                            placeholder: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "loaiIV",
                        header: "Loại IV"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.loaiIV,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiIV) = $event),
                            placeholder: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "loaiV",
                        header: "Loại V"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.loaiV,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiV) = $event),
                            placeholder: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "VII. Công tác huấn luyện" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_130, [
              _createElementVNode("div", _hoisted_131, [
                _createElementVNode("div", _hoisted_132, [
                  _createVNode(_component_DataTable, {
                    value: $setup.baoCaoCoSoLaoDong.congTacHuanLuyens,
                    showGridlines: "",
                    rows: 40,
                    rowHover: true,
                    style: {"font-size":"14px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ColumnGroup, { type: "header" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "TT",
                                rowspan: 2
                              }),
                              _createVNode(_component_Column, {
                                header: "Nội dung huấn luyện",
                                rowspan: 2
                              }),
                              _createVNode(_component_Column, {
                                header: "Số lượng người được huấn luyện",
                                colspan: 2
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "Tổng số",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Số nữ",
                                colspan: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        header: "Stt",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputText, {
                            id: "noiDungHuanLuyen",
                            type: "text",
                            modelValue: slotProps.data.noiDungHuanLuyen,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.noiDungHuanLuyen) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSo,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event),
                            placeholder: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.soNu,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNu) = $event),
                            placeholder: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "VIII. Kinh phí chi trả cho công tác vệ sinh lao động, chăm sóc sức khỏe người lao động" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_133, [
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("div", _hoisted_135, [
                  _createVNode(_component_DataTable, {
                    value: $setup.baoCaoCoSoLaoDong.kinhPhiChiTras,
                    showGridlines: "",
                    rows: 40,
                    rowHover: true,
                    style: {"font-size":"14px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "Stt",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "noiDungHoatDong",
                        header: "Nội dung hoạt động"
                      }),
                      _createVNode(_component_Column, {
                        field: "soTien",
                        header: "Số tiền"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.soTien,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTien) = $event),
                            placeholder: "",
                            mode: "currency",
                            currency: "VND",
                            locale: "vi-VN"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "ghiChu",
                        header: "Ghi chú"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputText, {
                            id: "ghiChu3",
                            type: "text",
                            modelValue: slotProps.data.ghiChu,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "IX. Các kiến nghị và kế hoạch dự kiến trong kỳ báo cáo tới" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_136, [
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("div", _hoisted_138, [
                  _createVNode(_component_Textarea, {
                    modelValue: $setup.baoCaoCoSoLaoDong.cacKienNghiVaKeHoach,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.baoCaoCoSoLaoDong.cacKienNghiVaKeHoach) = $event)),
                    rows: "10"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_139, [
                  _createVNode(_component_Button, {
                    label: "Gởi báo cáo",
                    icon: "pi pi-upload",
                    severity: "secondary",
                    raised: "",
                    onClick: $setup.addReport
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_140, [
      _createElementVNode("div", _hoisted_141, [
        _createElementVNode("div", _hoisted_142, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}